import React, { useEffect, useState } from 'react';
import AuthUser from './AuthUser';
import toast, { Toaster } from "react-hot-toast";
import { Link } from 'react-router-dom';

export default function StudentTemplateList() {
    const { http, user } = AuthUser();
    const [templates, setTemplates] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchTemplates();
    }, []);

    const fetchTemplates = () => {
        setIsLoading(true);
        http.get(`/student_templates?company_id=${user.company_id}`)
            .then((res) => {
                setTemplates(res.data.data || []);
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
                toast.error("Error loading templates");
            });
    };

    const handleDelete = (id, name) => {
        if (!window.confirm(`Delete template "${name}"?`)) return;
        http.delete(`/student_template_del/${id}`)
            .then(() => {
                toast.success("Template deleted");
                fetchTemplates();
            })
            .catch(() => toast.error("Error deleting template"));
    };

    const fieldLabels = {
        ext_10: 'Student Type',
        adm_date: 'Admission Date',
        ext_9: 'Gender',
        gvt_no: 'STS Number',
        year: 'Year',
        class: 'Class',
        section: 'Section',
        roll_no: 'Roll No',
        ext_7: 'Sibling',
        ext_8: 'Identity Marks',
        group_name: 'Group Name',
        dob: 'DOB',
        category: 'Category',
        mobile: 'Mobile',
        religion: 'Religion',
        cast: 'Caste',
        ext_15: 'Caste Category',
        adhar: 'Aadhaar',
        email: 'Email',
        club: 'Other Remark',
        revise_agent_id: 'Revise Agent',
        ext_17: 'Agent Amount',
        ext_12: 'Transport',
        ext_13: 'Way',
        ext_16: 'Pickup Location',
        ext_14: 'Previous Class',
        father: "Father's Name",
        ext_1: "Father's Phone",
        father_occ: "Father's Occupation",
        mother: "Mother's Name",
        mother_phone: "Mother's Phone",
        mother_occu: "Mother's Occupation",
        guardian_name: "Guardian's Name",
        guardian_relation: "Guardian's Relation",
        guardian_occu: "Guardian's Occupation",
        guardian_phone: "Guardian's Phone",
        guardian_address: "Guardian's Address",
        ext_4: 'Current Address',
        ext_5: 'Permanent Address',
        pre_school: 'Previous School',
        tc_num: 'Head',
        head_receipt: 'Head Receipt',
        alpha: 'Alpha',
        reported: 'Reported',
    };

    return (
        <>
            <Toaster />
            <div className="container mt-2">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3>Student Templates</h3>
                    <Link to="/student_template_add" className="btn btn-primary">
                        <i className="fa fa-plus me-1"></i> Add Template
                    </Link>
                </div>

                {isLoading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary"></div>
                    </div>
                ) : templates.length === 0 ? (
                    <div className="text-center py-5 text-muted">
                        <i className="fa fa-file-alt fa-3x mb-3" style={{ opacity: 0.3 }}></i>
                        <p>No templates created yet</p>
                        <Link to="/student_template_add" className="btn btn-outline-primary btn-sm">
                            Create your first template
                        </Link>
                    </div>
                ) : (
                    <div className="row g-3">
                        {templates.map((tpl) => {
                            const filledFields = Object.entries(fieldLabels)
                                .filter(([key]) => tpl[key] && tpl[key] !== '' && tpl[key] !== '0')
                                .map(([key, label]) => ({ key, label, value: key === 'reported' ? (tpl[key] == 1 ? 'Yes' : 'No') : tpl[key] }));

                            return (
                                <div key={tpl.id} className="col-md-6 col-lg-4">
                                    <div className="card h-100 shadow-sm">
                                        <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                                            <h6 className="mb-0 fw-bold">{tpl.template_name}</h6>
                                            <div>
                                                <Link to={`/student_template_edit/${tpl.id}`}
                                                    className="btn btn-sm btn-light me-1" title="Edit">
                                                    <i className="fa fa-edit"></i>
                                                </Link>
                                                <button className="btn btn-sm btn-danger"
                                                    onClick={() => handleDelete(tpl.id, tpl.template_name)} title="Delete">
                                                    <i className="fa fa-trash"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="card-body p-3">
                                            {filledFields.length === 0 ? (
                                                <small className="text-muted">No fields set</small>
                                            ) : (
                                                <div className="d-flex flex-wrap gap-1">
                                                    {filledFields.map(({ key, label, value }) => (
                                                        <span key={key} className="badge bg-light text-dark border" style={{ fontSize: '12px' }}>
                                                            {label}: <b>{value}</b>
                                                        </span>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </>
    );
}
